import { useNavigate, Navigate } from 'react-router-dom';
import { getMacro } from '../config/navigation';
import { useFavorites } from '../hooks/useFavorites';
import useIsMobile from '../hooks/useIsMobile';
import HubCard from '../components/shared/HubCard';

// Hub — pagina presentazionale di una macro-voce. Griglia di card che linkano
// alle PAGINE ESISTENTI (stesse route/viste). Nessuna logica di dominio, nessun
// fetch: è "pelle". Il breadcrumb è reso globalmente dalla topbar (Layout).
export default function Hub({ macroKey }) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { favorites, toggle } = useFavorites();
  const macro = getMacro(macroKey);

  // Route hub sconosciuta → torna alla Home (coerente con il catch-all di App.jsx).
  if (!macro) return <Navigate to="/" replace />;

  const Primary = macro.primary?.icon;

  return (
    <div style={{ padding: isMobile ? '20px 16px' : '28px 20px 28px 32px', width: '100%', boxSizing: 'border-box' }}>
      {/* Intestazione: titolo + descrizione + CTA primaria (dove esiste) */}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 14, marginBottom: 18, flexWrap: 'wrap' }}>
        <div>
          <h1 className="font-display" style={{ fontSize: 22, fontWeight: 500, letterSpacing: '-0.01em', color: 'var(--ink)', margin: 0 }}>
            {macro.label}
          </h1>
          <div style={{ fontSize: 13.5, color: 'var(--ds-muted)', marginTop: 2, maxWidth: '64ch' }}>
            {macro.desc}
          </div>
        </div>
        {macro.primary && (
          <button
            type="button"
            onClick={() => navigate(macro.primary.to)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, padding: '10px 15px',
              borderRadius: 'var(--radius-base)', fontWeight: 500, fontSize: 13,
              color: 'white', background: 'var(--brand)', border: 'none', cursor: 'pointer',
              boxShadow: '0 2px 10px rgba(46,160,132,0.18)', flexShrink: 0,
            }}
          >
            {Primary && <Primary size={16} strokeWidth={2.2} />}
            {macro.primary.label}
          </button>
        )}
      </div>

      {/* Griglia card → route esistenti (i Preferiti stanno nella barra persistente del Layout) */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 360px))', gap: 18, justifyContent: 'start' }}>
        {macro.cards.map((card) => (
          <HubCard
            key={card.label}
            card={card}
            color={macro.color}
            isFav={!!card.to && favorites.has(card.to)}
            onToggleFav={toggle}
          />
        ))}
      </div>
    </div>
  );
}
